import Guid from "_shared/guids/guid";
import Forum from "messaging/forums/forum";
import Topic from "messaging/forums/topics/topic";
import ForumInfoSchema, { ForumInfoJSON, ForumInfoParams } from "notifications/entities/forum-info/forum-info-schema";
import ForumEntityClass from "notifications/values/forum-entity-class/forum-entity-class";
import ForumName from "notifications/values/forum-name/forum-name";

export default class ForumInfo {
  public static create(values: ForumInfoParams): ForumInfo {
    const parsed = ForumInfoSchema.validate(values);
    return new ForumInfo(parsed);
  }

  public static fromJSON(value: ForumInfoJSON): ForumInfo {
    const parsed = ForumInfoSchema.deserialize(value);
    return new ForumInfo(parsed);
  }

  public readonly id: Guid;
  public readonly name: ForumName;
  public readonly entityClass: ForumEntityClass;
  public readonly entityId: Guid | null;

  public toJSON(): ForumInfoJSON {
    return ForumInfoSchema.serialize(this);
  }

  public isEqualTo(other: ForumInfo): boolean {
    return (
      this.id.isEqualTo(other.id) &&
      this.name.isEqualTo(other.name) &&
      this.entityClass.isEqualTo(other.entityClass) &&
      ((this.entityId === null && other.entityId === null) ||
        (this.entityId !== null && other.entityId !== null && this.entityId.isEqualTo(other.entityId)))
    );
  }

  public toString(): string {
    return `${this.name.toString()} [${this.entityClass.toString()}:${this.entityId?.value ?? "null"}]`;
  }

  public toForum(): Forum {
    return new Forum({
      id: this.id,
      name: this.name,
      topic: new Topic({
        entityClass: this.entityClass,
        entityId: this.entityId ?? undefined,
      }),
    });
  }
  public constructor(params: ForumInfoParams) {
    ForumInfoSchema.validate(params);
    this.id = params.id;
    this.name = params.name;
    this.entityClass = params.entityClass;
    this.entityId = params.entityId;
  }
}
